































































































import Vue from 'vue';
import moment from 'moment';
import CustomerFilterSettings from '../mpgroup/CustomerFilterSettings.vue';
import SelectSubscribeBox from '../../../rule/components/settings/create/SelectSubscribeBox.vue';
import ScheduleMsg from '../../../rule/components/settings/create/ScheduleTplMsg.vue';
import commonClient from '../../../common/apis';
import { TaskType } from '../../../common/models/TaskType';
import { MASS } from '../../models/Mass';
import format from '../../../customer/components/filter/makeCustomerQuery';
import { CustomerFilter } from '../../../customer/models/CustomerFilter';
import { WxTpl, transValue, transDiv } from '../../../rule/models/ScheduleMsg';
import customerVuex from '../../../customer/vuex/common';
import massVuex from '../../vuex/common';
import CustomerFilterDisplay from '../mpgroup/CustomerFilterDisplay.vue';
import AdminVerifyBox from '../common/AdminVerifyBox.vue';
import ScheduleTplMsgDisplay from '../../../rule/components/settings/create/ScheduleTplMsgDisplay.vue';

enum SelectType {
  Custom = 0,
  Subscribe = 1,
}

const selectType: SelectType = SelectType.Custom as SelectType;

export default Vue.extend({
  mixins: [customerVuex, massVuex],
  components: {
    CustomerFilterDisplay,
    CustomerFilterSettings,
    SelectSubscribeBox,
    ScheduleMsg,
    AdminVerifyBox,
    ScheduleTplMsgDisplay,
  },
  data() {
    return {
      showMessage: false,
      showAdminVerifyBox: false,
      SelectType,
      selectType,
      MASS,
      showScheduleMsg: true,
      hackId: 0,
      isTiming: false,
      timingDay: 1,
      timingTime: null,
      scheduleAt: null,
      expectCount: 0,
      dayList: [{value: 1, label: '今天'}, {value: 2, label: '明天'}],
      sendType: MASS.SEND_TYPE.TEMPLATE,
    };
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
  },
  methods: {
    changeSendType(isTiming: boolean) {
      this.isTiming = isTiming;
    },
    setExpectCount(expectCount: number) {
      this.expectCount = expectCount;
    },
    confirmMassSend() {
      const isPaidUser = this.accountState.crmLevel && !this.accountState.isExpired;
      const isTrial = this.accountState.isTrial && !isPaidUser;
      if (this.selectType === SelectType.Subscribe &&
          this.customerFilter.topics.length < 1) {
        this.$Message.warning('请选择订阅类型');
      } else if (!this.scheduleRuleState.scheduleRule.scheduleMsg || this.showScheduleMsg) {
        this.$Message.warning('请确认模板设置');
      } else if(this.expectCount > 1000 && isTrial) {
        this.$Message.warning('试用期间最多可群发1000人');
      } else if (this.isTiming) {
        if (!this.timingTime) {
          this.$Message.warning('请先设置时间');
        } else if (this.timingTime) {
          let day = null;
          if (this.timingDay === 1) {
            day = moment();
          } else {
            day = moment().add(1, 'days');
          }
          const dayText = day.format('YYYY-MM-DD');
          this.scheduleAt = moment(dayText + ' ' + this.timingTime);
          if (moment().add(5, 'minutes').isAfter(this.scheduleAt)) {
            this.$Message.warning('定时任务至少在当前时间的5分钟后');
          } else {
            this.showAdminVerifyBox = true;
          }
        }
      } else {
        this.showAdminVerifyBox = true;
      }
    },
    updateTimingTime(val: string) {
      this.timingTime = val;
    },
    isFromFilter() {
      const href = window.location.href;
      return href.indexOf('from=filter') !== -1;
    },
    doMassSend(data: any) {
      let filter: CustomerFilter = JSON.parse(JSON.stringify(this.customerFilter));
      if (this.selectType === SelectType.Custom) {
        filter.topics = [];
      } else {
        filter = {
          topics: filter.topics,
        } as CustomerFilter;
      }
      if (this.scheduleMsg.WxTpl) {
        const keys = Object.keys(this.scheduleMsg.WxTpl.params);
        keys.forEach((i) => {
          this.scheduleMsg.WxTpl.params[i].value = transDiv(transValue(this.tranProps, this.scheduleMsg.WxTpl.params[i].value));
        });
      }
      commonClient.createTask({
        input: {
          MassSend: {
            query: format.mkFilterQueries(filter),
            msg: this.scheduleMsg,
          },
        },
        expectCount: this.expectCount,
        taskType: TaskType.TemplateSend,
        isTiming: this.isTiming,
        creator: data.openid,
        creatorName: data.name,
        scheduleAt: this.isTiming ? this.scheduleAt.format('YYYY-MM-DD HH:mm:ss') : null,
      }).success(() => {
        this.$Message.success('创建成功');
        this.showAdminVerifyBox = false;
        this.$router.push('/mass/records');
      });
    },
    wxTpl(): WxTpl | null {
      if (this.scheduleRuleState.scheduleRule.scheduleMsg) {
        return this.scheduleRuleState.scheduleRule.scheduleMsg.WxTpl;
      } else {
        return null;
      }
    },
    wxTemplateId(): string | null {
      return this.wxTpl() ? this.wxTpl()!.templateId : null;
    },
    confirmFilterCustomer() {
      this.showMessage = true;
    },
    adminConfirm(data: any) {
      this.doMassSend(data);
    },
    backToFilter() {
      window.location.href = '#/customer/filter?back=true';
    },
  },
  mounted() {
    if (this.isFromFilter()) {
      this.showMessage = true;
    }
  },
});
